'use strict';
const angular = require('angular');

export default angular.module('appApp.maintocselectiondensity', [])
  .directive('maintocselectiondensity', function() {
    return {
      template: require('./maintocselectiondensity.html'),
      restrict: 'EA',
      link: function(scope, element, attrs) {}
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/directives/maintocselectiondensity/maintocselectiondensity.directive.js